import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import Login from '@/components/Login';
import Dashboard from '@/components/dashboard/Dashboard'
import ComingSoon from '@/components/todo/ComingSoon';

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: '/',
      name: 'Main',
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard,
        },
        {
          path: '/dashboard-configuration',
          name: 'Dashboard Configuration',
          component: () => import(/* webpackChunkName: "DashboardConfiguration" */ '@/components/dashboard/configuration/DashboardConfiguration')
        },
        {
          path: '/coming-soon',
          name: 'Coming Soon',
          component: ComingSoon
        },
        // {
        //   name: 'SalesOrderOverlay',
        //   path: '/sales-order/:sono',
        //   component: () => import(/* webpackChunkName: "SalesOrderOverlay" */ '@/components/overlays/sales_orders/SalesOrderOverlay'),
        //   props: route => ({
        //     sono: route.params.sono
        //   })
        // },
        {
          path: '/admin/acl-management',
          name: 'ACL',
          component: () => import(/* webpackChunkName: "ACL" */'@/components/acl/ACL')
        },
        {
          path: '/warehouse/shipping',
          name: 'Shipping',
          component: () => import(/* webpackChunkName: "Shipping" */'@/components/shipping/Shipping')
        },
        {
          path: '/warehouse/packaging',
          name: 'Packaging',
          component: () => import(/* webpackChunkName: "Packaging" */'@/components/packaging/Packaging')
        },
        {
          path: '/products/product-import',
          name: 'ItemFiles',
          component: () => import(/* webpackChunkName: "ItemFiles" */ '@/components/item_files/ItemFiles')
        },
        {
          path: '/products/attributes',
          name: 'ProductAttributes',
          component: () => import(/* webpackChunkName: "ProductAttributes" */ '@/components/product_attributes/ProductAttributes')
        },
        {
          path: '/products/item-entry',
          name: 'ItemEntry',
          component: () => import(/* webpackChunkName: "ItemEntry" */ '@/components/item_entry/ItemEntry')
        },
        {
          path: '/products/categories',
          name: 'Categories',
          component: () => import(/* webpackChunkName: "Categories" */ '@/components/categories/Categories')
        },
        {
          path: '/action-items/custom-action-items',
          name: 'CustomActionItems',
          component: () => import(/* webpackChunkName: "CustomActionItems" */ '@/components/action_items/CustomActionItems')
        },
        { // c# test
          path: '/products/item-entry/cNumber',
          name: 'CNumberDisplayLink',
          component: () => import(/* webpackChunkName: "CNumberDisplayLink" */ '@/components/overlays/CNumberDisplayLink')
        },
        {
          path: '/products/item-desc',
          name: 'ItemDesc',
          component: () => import(/* webpackChunkName: "ItemDesc" */ '@/components/item_desc/ItemDesc')
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
  ]
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
